import{jsx as _jsx}from"react/jsx-runtime";import React from"react";import{rfmMerge}from"../../rfmMerge.js";/**
 * A label for a list item.
 *
 * @param props The props for the label.
 * @returns The rendered label.
 */const ListItemLabel=props=>{const{text,className:extendedClassName,...rest}=props;if(!text)return null;const className=rfmMerge(`rfm:self-center rfm:pt-1 rfm:dark:text-white`,extendedClassName);return /*#__PURE__*/_jsx("label",{className:className,...rest,children:text})};export default ListItemLabel;